<app-form-section title="Correos Electrónicos" icon="email" iconColor="green">
  <div class="table-container">
    <table mat-table  [dataSource]="emails" class="w-full">
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Correo Electrónico</th>
        <td mat-cell *matCellDef="let email">{{ email.email }}</td>
      </ng-container>

      <ng-container matColumnDef="statusId">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
        <td mat-cell *matCellDef="let email" class="px-6 text-left">
          <mat-slide-toggle [checked]="email.statusId === 1" (change)="onStatusToggle($event.checked, email)"
            color="primary">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <button color="primary" mat-button (click)="openEmailModal()" matTooltip="Agregar Email">
            <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let email">
          <div class="button-container flex gap-2">
            <button mat-icon-button (click)="openEmailModal(email)" matTooltip="Editar Registro">
              <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
            </button>
            <button mat-icon-button (click)="openDeleteEmail(email)" matTooltip="Eliminar Registro">
              <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsEmail"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsEmail"></tr>
    </table>
  </div>
</app-form-section>